package com.example.mystybag.common.helpers

import com.example.mystybag.communication.CommunicationProtocol
import com.example.mystybag.core.expected.logException
import com.example.mystybag.core.security.Security
import com.example.mystybag.core.security.SecurityUtils

object CommunicationProtocolImpl: CommunicationProtocol {
    override suspend fun sing(text: String): String  = Security.sign(text)
    override suspend fun signRequest(request: String): String? = Security.signRequest(request)
    override suspend fun encryptRequest(request: String): String? = Security.encryptRequest(request)
    override fun kvSerial(serial: String): String = SecurityUtils.kvSerial(serial)
    override fun logMessage(message: String) = logException(Exception(message))
}